/**
 * @file 申請区分変更
 *
 */
'use strict';
import Common from '../../Utils/Common';

/**
 * @classname ChangeMemberType
 * @classdesc 申請区分変更
 */
export default class ChangeMemberType {
	/**
	 * @constructor
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 */
	constructor($e, controller) {
		console.log('ChangeMemberType.constructor');
		this._controller = controller;
		$e.on('click', () => this.onClick());
		this._controller._memberFlg = false;
		// 初期状態で加盟員にチェックかどうか
		if ($('#current-member-flg').val() === '1') {
			this._controller._memberFlg = true;
		}
		console.log(this._controller._memberFlg);
	};


	/**
	 * clickのコールバック
	 *
	 * @memberof ChangeMemberType
	 * @return {undefined}
	 */
	onClick() {
		console.log('ChangeMemberType.onClick');
		const $nonMember = $('#non-member-wrap');
		const $member = $('#member-wrap');
		const $title = $('#title-wrap');
		const $beaverTitle = $('#beaver-title-wrap');
		const $parentContact = $('#parent-contact');
		const $cohabitantExemptionMemberId = $('#cohabitant-exemption-member-id');
		const $feeExemptionMemberId = $('#fee-exemption-member-id');
		const $feeExemptionReasonOther = $('#fee-exemption-reason-other');
		const $deliveryAddressWrap = $('#delivery_address_wrap');
		const $discontinuedWrap = $('#discontinued-wrap');
		const $oldMemberWrap = $('#ob-og-mail-wrap');
		const $obOgWrap = $('#ob-og-wrap');
		const $discontinuedReasonOther = $('#discontinued-reason-other');
		if ($('[name=member_apply_type]:checked').val() === '1') {
			// 加盟員の場合
			console.log('加盟員の場合');
			$member.show().find('.validate').removeClass('ignore-validate');
			$title.show().find('.validate').removeClass('ignore-validate');
			$beaverTitle.hide();
			$parentContact.hide();
			Common.addIgnoreValidate($nonMember);
			Common.addIgnoreValidate($deliveryAddressWrap);
			Common.addIgnoreValidate($beaverTitle);
			$('#main_title_id').html(`<option value="">--</option>`);
			$obOgWrap.hide();
			Common.addIgnoreValidate($oldMemberWrap);
		} else if ($('[name=member_apply_type]:checked').val() === '2') {
			// 非加盟員の場合
			console.log('非加盟員の場合');
			$nonMember.show().find('.validate').removeClass('ignore-validate');
			$cohabitantExemptionMemberId.hide();
			$feeExemptionMemberId.hide();
			$feeExemptionReasonOther.hide();
			$deliveryAddressWrap.hide();
			Common.addIgnoreValidate($member);
			Common.addIgnoreValidate($cohabitantExemptionMemberId);
			Common.addIgnoreValidate($feeExemptionMemberId);
			Common.addIgnoreValidate($feeExemptionReasonOther);
			Common.addIgnoreValidate($deliveryAddressWrap);
			$('#discontinued').prop('checked', false);
			Common.addIgnoreValidate($discontinuedWrap);
			Common.addIgnoreValidate($discontinuedReasonOther);
			$('#ob_og_y').click();
			Common.addIgnoreValidate($oldMemberWrap);
			$('#personal-information-wrap').hide();
			$('#protection_enabled_y').click();
			$('#mobile').prop('readonly', false);
			// 加盟員から非加盟員になった場合の処理
			if(this._controller._memberFlg){
				$obOgWrap.show();
			}else{
				$obOgWrap.hide();
			}
		} else if ($('[name=member_apply_type]:checked').val() === '3') {
			// ビーバースカウト事前申請の場合
			console.log('ビーバースカウト事前申請の場合');
			$member.show().find('.validate').removeClass('ignore-validate');
			$beaverTitle.show().find('.validate').removeClass('ignore-validate');
			$title.hide();
			$parentContact.show();
			Common.addIgnoreValidate($nonMember);
			Common.addIgnoreValidate($deliveryAddressWrap);
			Common.addIgnoreValidate($title);
			$obOgWrap.hide();
		}
	};
}
